import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

declare global {
  interface Window {
    TradingView: any;
  }
}

interface TradingViewWidgetProps {
  symbol?: string;
  theme?: 'light' | 'dark';
  autosize?: boolean;
  height?: number;
}

export const TradingViewWidget: React.FC<TradingViewWidgetProps> = ({
  symbol = 'NASDAQ:AAPL',
  theme = 'dark',
  autosize = true,
  height = 500
}) => {
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const containerId = `tradingview_${Math.random().toString(36).substring(7)}`;
    if (container.current) {
      container.current.id = containerId;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://s3.tradingview.com/tv.js';
    script.async = true;
    
    const onScriptLoad = () => {
      if (window.TradingView && container.current) {
        new window.TradingView.widget({
          container_id: containerId,
          symbol: symbol,
          interval: 'D',
          timezone: 'exchange',
          theme: theme,
          style: '1',
          locale: 'en',
          toolbar_bg: '#f1f3f6',
          enable_publishing: false,
          allow_symbol_change: true,
          autosize: autosize,
          height: height,
          save_image: false,
          studies: [
            'MASimple@tv-basicstudies',
            'RSI@tv-basicstudies',
            'MACD@tv-basicstudies'
          ],
          show_popup_button: true,
          popup_width: '1000',
          popup_height: '650',
          container: containerId,
        });
      }
    };

    script.addEventListener('load', onScriptLoad);
    document.head.appendChild(script);

    return () => {
      script.removeEventListener('load', onScriptLoad);
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      // Clean up any TradingView elements
      const widgetContainer = document.getElementById(containerId);
      if (widgetContainer) {
        widgetContainer.innerHTML = '';
      }
    };
  }, [symbol, theme, autosize, height]);

  return (
    <Box 
      ref={container}
      sx={{ 
        width: '100%',
        height: autosize ? '100%' : height,
        backgroundColor: theme === 'dark' ? '#131722' : '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    />
  );
};

export default TradingViewWidget;
